// hooks/useSensitiveData.ts

import { maskAccountNumber, maskEmail, maskName, maskPhone, maskNickname } from '@/utils/helper';
import { useRoleCheck } from './useRoleCheck';
export function useSensitiveData() {
  const { isOwner } = useRoleCheck();
  // const isOwner = false;

  return {
    revealEmail: (email: string) => (isOwner ? email : maskEmail(email)),
    revealPhone: (phone: string) => (isOwner ? phone : maskPhone(phone)),
    revealName: (name: string) => (isOwner ? name : maskName(name)),
    revealNickname: (nickname: string) => (isOwner ? nickname : maskNickname(nickname)),
    revealAccount: (value: string) => (isOwner ? value : maskAccountNumber(value)),
    isOwner,
  };
}
